import deepmerge from 'deepmerge';
import React, { createContext } from 'react';
import type { DeepPartial } from '~/types';

export type ContextType = {
  dismissedEarthDayBanner: number;
  dismissedEVBanner: number;
  dismissedNewPrice: number;
  hasEVBannerUtm: boolean;
  openManageSavedSearchesModal: boolean;
  partnerId: number;
  sessionId: string;
  verboseLoggingEnabled: boolean;
};

const defaultContext: ContextType = {
  dismissedEarthDayBanner: 0,
  dismissedEVBanner: 0,
  dismissedNewPrice: 0,
  hasEVBannerUtm: false,
  openManageSavedSearchesModal: false,
  partnerId: 1,
  sessionId: '',
  verboseLoggingEnabled: false
};

const StaticContext = createContext<ContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<ContextType>;

export function StaticContextProvider({ children, ...props }: OwnProps) {
  return (
    <StaticContext.Provider value={props}>{children}</StaticContext.Provider>
  );
}

StaticContextProvider.displayName = 'StaticContextProvider';

export const generateStaticContext = (
  customState: DeepPartial<ContextType>
): ContextType =>
  deepmerge<ContextType, DeepPartial<ContextType>>(defaultContext, customState);

export function useVerboseLogging() {
  return React.useContext(StaticContext).verboseLoggingEnabled;
}

export default StaticContext;
